import { AssignmentTickets } from '../types/cart';
import { EventData } from '../types/wallet';

export const associatedFaceRecognitionInThisSession = (
  ticketsForThisEventInMyWallet: EventData[],
  namingData: AssignmentTickets,
) => {
  const ticketsWithTheSameSession = (ticketsForThisEventInMyWallet || []).filter((curTicket) => (
    curTicket.sessions.data.some((curDateFromTicketsInMyWallet) => (
      namingData.dates.some((curDateFromNamingData) => (
        curDateFromTicketsInMyWallet.id === curDateFromNamingData.id
      ))
    ))
  ));

  const hasAssociatedFaceInThisSession = ticketsWithTheSameSession.some((curTicket) => (
    curTicket.faceRecognition.associatedUser
  ));

  return hasAssociatedFaceInThisSession;
};
